<template>
  <div>
    <LoadingSpinner v-if="loading" />
    <section class="account" v-if="!loading">
      <div class="contenedor">
        <div>
          <div class="row">
            <div class="col-md-12">
              <div v-if="alertMessage">
                <div class="mt-4">
                  <AlertError :msgError="alertMessage" />
                </div>
              </div>
              <div class="form-group col-sm-8 row pr-0">
                <label for="inputPassword" class="col-sm-12">Email</label>
                <div class="col-sm-12 input-group mb-3 pr-0">
                  <input
                    type="text"
                    class="form-control"
                    pattern="^(?!.*@(?:gmail.com|yahoo.com|hotmail.com|aol.com|icloud.com|hotmail.co.uk|hotmail.fr|msn.com|yahoo.fr|wanadoo.fr|orange.fr|comcast.net|yahoo.co.uk|yahoo.com.br|yahoo.co.in|live.com|rediffmail.com|free.fr|gmx.de|web.de|yandex.ru|ymail.com|libero.it|outlook.com|uol.com.br|bol.com.br|mail.ru|cox.net|hotmail.it|sbcglobal.net|sfr.fr|live.fr|verizon.net|live.co.uk|googlemail.com|yahoo.es|ig.com.br|live.nl|bigpond.com|terra.com.br|yahoo.it|neuf.fr|yahoo.de|alice.it|rocketmail.com|att.net|laposte.net|facebook.com|bellsouth.net|yahoo.in|hotmail.es|charter.net|yahoo.ca|yahoo.com.au|rambler.ru|hotmail.de|tiscali.it|shaw.ca|yahoo.co.jp|sky.com|earthlink.net|optonline.net|freenet.de|t-online.de|aliceadsl.fr|virgilio.it|home.nl|qq.com|telenet.be|me.com|yahoo.com.ar|tiscali.co.uk|yahoo.com.mx|voila.fr|gmx.net|mail.com|planet.nl|tin.it|live.it|ntlworld.com|arcor.de|yahoo.co.id|frontiernet.net|hetnet.nl|live.com.au|yahoo.com.sg|zonnet.nl|club-internet.fr|juno.com|optusnet.com.au|blueyonder.co.uk|bluewin.ch|skynet.be|sympatico.ca|windstream.net|mac.com|centurytel.net|chello.nl|live.ca|aim.com|bigpond.net.au)+$).*$"
                    :title="$t('lang.accountcreation.email')"
                    v-model="emailAccount"
                  />
                </div>
                <small
                  v-if="this.isGmailAccount(this.emailAccount)"
                  class="text-danger ml-4"
                  >{{ $t("lang.validation.gmailsuit") }}</small
                >
              </div>
              <div class="form-group col-sm-8 row pr-0">
                <label for="inputPassword" class="col-sm-12">{{
                  $t("lang.label.firstname")
                }}</label>
                <div class="col-sm-12 input-group mb-3 pr-0">
                  <input
                    type="text"
                    class="form-control"
                    v-model="firstNameAccount"
                  />
                </div>
              </div>
              <div class="form-group col-sm-8 row pr-0">
                <label for="inputPassword" class="col-sm-12">{{
                  $t("lang.label.lastname")
                }}</label>
                <div class="col-sm-12 input-group mb-3 pr-0">
                  <input
                    type="text"
                    class="form-control"
                    v-model="lastNameAccount"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12 mt-2">
              <div class="my-4 text-right mr-5">
                <button
                  class="btn btn-primary btn-sm connect mr-2"
                  type="submit"
                  @click="connect()"
                >
                  {{ $t("lang.button.connect") }}
                </button>
                <button
                  class="btn btn-danger btn-sm connect"
                  type="submit"
                  @click="cancel()"
                >
                  {{ $t("lang.button.cancel") }}
                </button>
              </div>
            </div>
          </div>

          <div
            class="alert alert-danger alert-dismissible fade show"
            role="alert"
            v-if="errors.length"
          >
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <ul>
              <li><strong>Error!</strong></li>
              <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
            </ul>
          </div>
        </div>
        <!--//Card-->
      </div>
    </section>
  </div>
</template>
 <script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import Header from "@/components/Header.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { usersService } from "@/_services";
import i18n from "@/_helpers/i18n";
import $ from "jquery";
import AlertError from "@/components/AlertError.vue";

export default {
  data() {
    return {
      alertMessage: null,
      loading: true,
      emailProvider: "Gmail",
      emailAccount: "",
      firstNameAccount: "",
      lastNameAccount: "",
      isChecked: false,
      errors: [],
    };
  },

  props: {
    settings: Object,
    selectedUserId: {
      type: String,
      default: null,
    },
    provider:String
  },

  components: {
    LoadingSpinner,
    AlertError,
  },

  watch: {
    emailAccount() {
      this.emailAccount = this.$sanitize(this.emailAccount);
    },
    firstNameAccount() {
      this.firstNameAccount = this.$sanitize(this.firstNameAccount);
    },
    lastNameAccount() {
      this.lastNameAccount = this.$sanitize(this.lastNameAccount);
    },
  },

  computed: {
    ...mapState({
      headerTab: (state) => state.header.tab,
    }),

    user() {
      return this.$store.state.authentication.user;
    },
    isGmailSelected() {
      return this.emailProvider === "Gmail";
    },
    alert() {
      return this.$store.state.alert;
    },
  },

  created() {

    this.setEmailSettings();
    this.$store.dispatch("alert/clear");
    this.getUserData();
    return (this.loading = false);
  },

  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),

    setEmailSettings() {
      if (Object.entries(this.settings).length > 0) {
        this.emailAccount = this.settings.email;
        this.firstNameAccount = this.settings.first_name;
        this.lastNameAccount = this.settings.last_name;
        this.isChecked = true;
      }
    },

    validate() {
      this.errors = [];

      if (!this.emailAccount) {
        this.errors.push("Email is required.");
        return false;
      } else if (!this.validEmail(this.emailAccount)) {
        this.errors.push("The email field is invalid.");
        return false;
      } else if (this.isGmailAccount(this.emailAccount)) {
        this.errors.push(this.$t("lang.validation.gmailsuit"));
        return false;
      } else if (!this.validEmailCorporative(this.emailAccount)) {
        this.errors.push(this.$t("lang.label.youwillhavetoconfirmthatthisemailisyours"))
        return false;
      }
      if (!this.firstNameAccount) {
        this.errors.push("First name is required.");
        return false;
      }
      if (!this.lastNameAccount) {
        this.errors.push("Last name is required.");
        return false;
      }

      return true;
    },
    validEmail(email) {
      return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/.test(email);
    },
    validEmailCorporative(email) {
      return /^(?!.*@(?:yahoo.com|aol.com|icloud.com|yahoo.fr|wanadoo.fr|orange.fr|comcast.net|yahoo.co.uk|yahoo.com.br|yahoo.co.in|rediffmail.com|free.fr|gmx.de|web.de|yandex.ru|ymail.com|libero.it|uol.com.br|bol.com.br|mail.ru|cox.net|hotmail.it|sbcglobal.net|sfr.fr|verizon.net|googlemail.com|yahoo.es|ig.com.br|bigpond.com|terra.com.br|yahoo.it|neuf.fr|yahoo.de|alice.it|rocketmail.com|att.net|laposte.net|facebook.com|bellsouth.net|yahoo.in|hotmail.es|charter.net|yahoo.ca|yahoo.com.au|rambler.ru|hotmail.de|tiscali.it|shaw.ca|yahoo.co.jp|sky.com|earthlink.net|optonline.net|freenet.de|t-online.de|aliceadsl.fr|virgilio.it|home.nl|qq.com|telenet.be|me.com|yahoo.com.ar|tiscali.co.uk|yahoo.com.mx|voila.fr|gmx.net|mail.com|planet.nl|tin.it|ntlworld.com|arcor.de|yahoo.co.id|frontiernet.net|hetnet.nl|live.com.au|yahoo.com.sg|zonnet.nl|club-internet.fr|juno.com|optusnet.com.au|blueyonder.co.uk|bluewin.ch|skynet.be|sympatico.ca|windstream.net|mac.com|centurytel.net|chello.nl|aim.com|bigpond.net.au)+$).*$/.test(email)
    },
    isGmailAccount(email) {
      return false;
      return (
        email !== undefined &&
        email.includes("@gmail.com") &&
        this.user.client_id != 435
      );
    },
    cancel() {
      this.$parent.cancel();
    },

    getUserData() {
      usersService.getUserById(this.selectedUserId).then((result) => {
        this.emailAccount = result.user.email;
        this.firstNameAccount = result.user.name;
        this.lastNameAccount = result.user.lastname;
      });
    },

    connect() {


      if (this.validate()) {
        this.alertMessage = null
        usersService
          .getAuthenticationUrl(
            this.emailAccount,
            this.firstNameAccount,
            this.lastNameAccount,
            this.selectedUserId,
            'calendar_spark',
            this.provider
          )
          .then(
            (result) => {
              window.open(result, "_self");
            },
            (error) => {
              if(error === 'Email alredy exists'){
                this.alertMessage = this.$t('lang.calendar.error_email')
              }
              if(error === 'OnlyGmailOutlook'){
                this.alertMessage = this.$t('lang.calendar.error_gmailoutlook')
              }
            }
          );
      }
    },
  },
};
</script>
    <style>
.email-account .icon img {
  width: 25px;
}
.email-account .icon-envelope-open-o:before {
  font-size: 25px;
}

.input-group-text.icon-check-circle {
  color: #52be80;
}
.account button.connect {
  height: auto;
}
</style>
